function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M4.73 7.05V5.728h11V7.05z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M4.73 11.403V10.08h11v1.323z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M4.73 20.107v-1.322h11v1.322z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M4.73 15.755v-1.322h11v1.322z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M26.753 4.916L20.22 3.398v2.235l5.606 1.302c.569.133.914.667.772 1.194l-4.227 15.586-.048.177-.382 1.41-.226.835-.36 1.324c-.143.527-.72.847-1.289.715l-2.81-.653a4.035 4.035 0 0 1-.766.074H7.96l11.892 2.764c1.594.37 3.21-.526 3.61-2.001l1.086-4.005.26-.957.35-1.288.08-.299L28.914 8.26c.4-1.476-.567-2.972-2.161-3.343z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M3.343 24.451c-.588 0-1.063-.439-1.063-.981V3.587c0-.542.475-.981 1.063-.981h14.875c.587 0 1.063.44 1.063.981V23.47c0 .542-.476.981-1.063.981zM21.56 3.191c0-1.517-1.332-2.747-2.975-2.747H2.976C1.331.444 0 1.674 0 3.192v20.673c0 1.518 1.332 2.748 2.975 2.748h15.61c1.644 0 2.976-1.23 2.976-2.748z"
}))));

var SvgBlankingIcon = function SvgBlankingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlankingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blanking_icon.931a5213.svg";
export { ForwardRef as ReactComponent };